import { render, staticRenderFns } from "./SweetModals.vue?vue&type=template&id=0bdbcf9c&"
import script from "./SweetModals.vue?vue&type=script&lang=js&"
export * from "./SweetModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdbcf9c')) {
      api.createRecord('0bdbcf9c', component.options)
    } else {
      api.reload('0bdbcf9c', component.options)
    }
    module.hot.accept("./SweetModals.vue?vue&type=template&id=0bdbcf9c&", function () {
      api.rerender('0bdbcf9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/components/SweetModals.vue"
export default component.exports